import Vue from 'vue';
import Vuetify from 'vuetify/lib/framework';

Vue.use(Vuetify);

const vuetify = new Vuetify({
    theme: {
        themes: {
            light: {
                primary: '#800',
                secondary: '#ffd700',
                bgcolor: '#EDECEC',
            },
            dark: {
                primary: '#800',
                secondary: '#ffd700',
                bgcolor: '#EDECEC',
            },
        },
    },
})

export default vuetify